<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import MessageApi from 'dashboard/api/inbox/message';
import wootConstants from 'dashboard/constants/globals';
import Modal from 'dashboard/components/Modal.vue';
import ModalHeader from 'dashboard/components/ModalHeader.vue';

const props = defineProps({
  chatId: { type: [String, Number], required: true },
});

const emit = defineEmits(['close']);

const { t } = useI18n();

const isLoading = ref(true);
const transferHistory = ref([]);

onMounted(async () => {
  try {
    const { data } = await MessageApi.getPreviousMessages({
      conversationId: props.chatId,
    });
    
    // Filter for activity messages
    const activityMessages = data.payload.filter(
      m => m.message_type === wootConstants.MESSAGE_TYPE.ACTIVITY
    );

    // Filter only those containing team or agent assignment related keywords
    const keywords = ['equipe', 'team', 'setor', 'sector', 'atribuíd', 'designa', 'assigned', 'desatribuíd', 'unassigned'];
    const transfers = activityMessages.filter(m => 
      keywords.some(k => m.content && m.content.toLowerCase().includes(k))
    );

    transferHistory.value = transfers.sort((a, b) => b.created_at - a.created_at);
  } catch (error) {
    // Ignore error
  } finally {
    isLoading.value = false;
  }
});

const close = () => {
  emit('close');
};
</script>

<template>
  <Modal :show="true" :on-close="close">
    <ModalHeader
      header-title="Histórico de Transferências"
      header-content="Detalhes das transferências de equipe e atendente desta conversa"
    />
    <div class="p-8">
      <div v-if="isLoading" class="text-center py-4">Carregando...</div>
      <div v-else-if="!transferHistory.length" class="text-center text-n-slate-11 py-4">
        Nenhum histórico encontrado.
      </div>
      <ul v-else class="space-y-4 max-h-[60vh] overflow-y-auto pr-2">
        <li
          v-for="item in transferHistory"
          :key="item.id"
          class="flex flex-col gap-1 border-b border-n-weak pb-3 last:border-0"
        >
          <div class="text-sm text-n-slate-12 font-medium">
            {{ item.content }}
          </div>
          <div class="text-xs text-n-slate-11">
            {{ new Date(item.created_at * 1000).toLocaleString() }}
          </div>
        </li>
      </ul>
    </div>
  </Modal>
</template>
